import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relative overflow-hidden" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MediaHandler = _resolveComponent("MediaHandler")!
  const _component_CMSLinkHandler = _resolveComponent("CMSLinkHandler")!
  const _directive_delegate_html_links = _resolveDirective("delegate-html-links")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_component_MediaHandler, {
      "media-aspect-ratio": _ctx.aspectRatio,
      "media-block": _ctx.content.media,
      "video-autoplay-override": _ctx.content.autoPlay
    }, null, 8, ["media-aspect-ratio", "media-block", "video-autoplay-override"]),
    _createElementVNode("div", {
      class: _normalizeClass(["p-20 w-full max-w-750 md:mx-auto", _ctx.content.placeTextOnImage ? 'xy-center  text-center' : 'md:my-20']),
      style: _normalizeStyle('color:' + _ctx.content.textColor)
    }, [
      (_ctx.content.subheading)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "o-text-caption uppercase m-0",
            innerHTML: _ctx.content.subheading
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.content.title)
        ? (_openBlock(), _createElementBlock("h2", {
            key: 1,
            class: "text-current-color",
            innerHTML: _ctx.content.title
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.content.text)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "mt-15 text-current-color magic-line-on-child-links text-dusty-grey-on-child-links",
            innerHTML: _ctx.content.text
          }, null, 8, _hoisted_4)), [
            [_directive_delegate_html_links]
          ])
        : _createCommentVNode("", true),
      (_ctx.content.primaryLink)
        ? (_openBlock(), _createBlock(_component_CMSLinkHandler, {
            key: 3,
            "link-block": _ctx.content.primaryLink,
            "style-as-button": true,
            class: "mt-15"
          }, null, 8, ["link-block"]))
        : _createCommentVNode("", true)
    ], 6)
  ]))
}